import { useCallback, useState } from "react";
import { useDownloadReport } from "../../../../../../../lib/hooks/useDownloadReport";
import { useOpenProgressModal } from "../../../../../../../lib/hooks/useOpenProgressModal";
import UserReportService from "../../../../../../../services/accounts/userReportGeneration";
import { SUCCESS_PDF_DOWNLOAD } from "../../../../../../../lib/constants";

export const usePrintReport = (
  request: any,
  contractNumber: number,
  apiName: string,
  name: string,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { download } = useDownloadReport(setIsLoading);

  const { openModal } = useOpenProgressModal(
    `Generating ${name}`,
    `Generating ${name} failed`,
    (id?: string) => {
      download(UserReportService, id);
    },
    {
      customMsg: SUCCESS_PDF_DOWNLOAD,
    },
  );

  const print = useCallback(async () => {
    try {
      setIsLoading(true);

      const id: string = await UserReportService.generateHistoryReport(
        request,
        contractNumber,
        apiName,
      );

      openModal(id);

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [apiName, contractNumber, openModal, request]);

  return { print, isLoading };
};
